import { lazy } from "react";

export const HospitalsDataAsync = lazy(() => import("./HospitalsData"));
